export const CARD_HEIGHT = 65;
export const CARD_REDUCED_HEIGHT = 35;

export const CARD_MARGIN_BOTTOM = 8;
export const CARD_TOP = 20;

export const CARD_AVATAR_DIMENSION = 20;
